import { FC } from 'react';
import { Box, Paper } from '@mui/material';
import { MessageResponseDTO } from '../../../../type/dto/RequestResponseDTO';
import { MessageHeader } from './MessageHeader';
import { MessageText } from './MessageText';
import { MessageImages } from './MessageImages';
import { OfferCard } from './OfferCard';

interface MessageTimelineItemProps {
    message: MessageResponseDTO;
    userName: string;
    userRole: string;
    isOfferExpanded: boolean;
    onToggleOffer: () => void;
    onImageClick: (imageUrl: string) => void;
}

export const MessageTimelineItem: FC<MessageTimelineItemProps> = ({
    message,
    userName,
    userRole,
    isOfferExpanded,
    onToggleOffer,
    onImageClick,
}) => {
    return (
        <Paper
            elevation={1}
            sx={{
                p: 2,
                mb: 2,
                borderLeft: '4px solid',
                borderLeftColor: userRole === 'Client' ? 'primary.main' : 'secondary.main',
                position: 'relative',
            }}
        >
            <MessageHeader
                userName={userName}
                userRole={userRole}
                messageType={message.messageType}
                createdAt={message.createdAt}
            />

            <Box sx={{ ml: 6.5 }}>
                {message.text && <MessageText text={message.text} />}

                {message.images && (
                    <MessageImages
                        images={message.images}
                        onImageClick={onImageClick}
                    />
                )}

                {message.offer && (
                    <OfferCard
                        offer={message.offer}
                        isExpanded={isOfferExpanded}
                        onToggle={onToggleOffer}
                        onImageClick={onImageClick}
                    />
                )}
            </Box>
        </Paper>
    );
};

